import { IOrderPricingProps, IOutcomePricingProps } from "../../props/general/price";

const PricingService = {
    order: {
        calculate: (data: IOrderPricingProps, method: string): IOrderPricingProps => {
            let originalPrice = "0";
            let calculatedPrice = Number(data.price);
            if (method === 'perquantity') {
                calculatedPrice = calculatedPrice * Number(data.quantityAmount || "0");
            }

            if (data.includePPn) {
                if (data.ppnPercentage && data.ppnPercentage !== 'custom') {
                    originalPrice = (calculatedPrice * 100 / (100 + Number(data.ppnPercentage))).toFixed();
                } else {
                    originalPrice = (calculatedPrice- Number(data.ppn)).toFixed();
                }
            } else if (!data.includePPn) {
                originalPrice = calculatedPrice + "";
            }
    
            let ppn = "0";
            if (data.includePPn && data.ppnPercentage && data.ppnPercentage !== 'custom') {
                ppn = (Number(originalPrice) * (Number(data.ppnPercentage) / 100)).toFixed();
            } else if (!data.includePPn && data.ppnPercentage && data.ppnPercentage !== 'custom') {
                ppn = (calculatedPrice * (Number(data.ppnPercentage) / 100)).toFixed();
            }
            data.ppn = ppn;
    
            let pph = "0";
            if (data.pphPercentage && data.pphPercentage !== 'custom') {
                pph = (Number(originalPrice) * (Number(data.pphPercentage) / 100)).toFixed();
            }
            data.pph = pph;
    
            let finalPrice = 0;
            if (data.includePPn && data.includePPh) {
                finalPrice = calculatedPrice;
            } else if (data.includePPn && !data.includePPh) {
                finalPrice = calculatedPrice + Number(data.pph);
            } else if (!data.includePPn && data.includePPh) {
                finalPrice = calculatedPrice + Number(data.ppn);
            } else {
                finalPrice = calculatedPrice + Number(data.ppn) + Number(data.pph);
            }
            data.finalPrice = finalPrice + "";
    
            let nettPrice = finalPrice;
            let invoicePrice = finalPrice;
            if (data.includePPn) {
                nettPrice = nettPrice - Number(data.ppn);
            }
            if (data.includePPh) {
                nettPrice = nettPrice - Number(data.pph);
            }
            
            invoicePrice = invoicePrice - Number(data.pph);
            data.invoicePrice = invoicePrice + "";

            return data;
        }
    },
    outcome: {
        calculate: (data: IOutcomePricingProps): IOutcomePricingProps => {
            let originalPrice = "0";

            if (data.includePPn) {
                if (data.ppnPercentage && data.ppnPercentage !== 'custom') {
                    originalPrice = (Number(data.price) * 100 / (100 + Number(data.ppnPercentage))).toFixed();
                } else {
                    originalPrice = (Number(data.price) - Number(data.ppn)).toFixed();
                }
            } else if (!data.includePPn) {
                originalPrice = data.price;
            }

            let ppn = "0";
            if (data.includePPn && data.ppnPercentage && data.ppnPercentage !== 'custom') {
                ppn = (Number(originalPrice) * (Number(data.ppnPercentage) / 100)).toFixed();
            } else if (!data.includePPn && data.ppnPercentage && data.ppnPercentage !== 'custom') {
                ppn = (Number(data.price) * (Number(data.ppnPercentage) / 100)).toFixed();
            }
            data.ppn = ppn;

            let pph = "0";
            if (data.pphPercentage && data.pphPercentage !== 'custom') {
                pph = (Number(originalPrice) * (Number(data.pphPercentage) / 100)).toFixed();
            }
            data.pph = pph;

            let finalPrice = 0;
            if (data.includePPn && data.includePPh) {
                finalPrice = Number(data.price);
            } else if (data.includePPn && !data.includePPh) {
                finalPrice = Number(data.price) + Number(data.pph);
            } else if (!data.includePPn && data.includePPh) {
                finalPrice = Number(data.price) + Number(data.ppn);
            } else {
                finalPrice = Number(data.price) + Number(data.ppn) + Number(data.pph);
            }
            data.finalPrice = finalPrice.toFixed(2);
            data.invoicePrice = (finalPrice - Number(data.pph)).toFixed(2);

            return data;
        }
    }
};

export default PricingService;